<template>
  <div>
    <h3 class="d-flex justify-space-between align-center">
      <v-btn
        icon
        color="grey"
        @click="toBack"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span style="min-width: 36px" />
    </h3>
    <v-row>
      <v-col
        cols="12"
        md="6"
        offset-md="3"
        class="pb-5"
      >
        <v-card>
          <v-card-title>送信先の選択</v-card-title>
          <v-card-subtitle>
            「送信」ボタンを押すことでメールアドレス、または携帯電話番号宛にパスワード再設定URLが送信されます。<br />
            URLにアクセスして新しいパスワードを設定してください。
          </v-card-subtitle>
          <v-card-text>
            <v-row
              v-if="user.email"
              send_type="email"
            >
              <v-col cols="12" md="6">
                <div class="fieldsetLabel">
                  <fieldset>
                    <legend>メールアドレス</legend>
                    <span>{{ user.email }}</span>
                  </fieldset>
                  <v-divider />
                </div>
              </v-col>
            </v-row>
            <v-row
              v-if="user.mobile_number"
              send_type="sms"
            >
              <v-col cols="12" md="6">
                <div class="fieldsetLabel">
                  <fieldset>
                    <legend>携帯電話番号</legend>
                    <span>{{ user.mobile_number }}</span>
                  </fieldset>
                  <v-divider />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="user.email && user.mobile_number">
              <v-col
                cols="12"
                md="4"
              >
                <h4>送信方法</h4>
                <v-radio-group
                  v-model="send_type"
                  row
                  dense
                  hide-details="auto"
                  class="pa-0 ma-0"
                >
                  <v-radio
                    label="メール"
                    value="email"
                  />
                  <v-radio
                    label="SMS"
                    value="sms"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="!user.email&&!user.mobile_number">
              <v-col cols="12" md="12">
                <div class="fieldsetLabel">
                  <fieldset>
                    <span>管理者へパスワード再設定を要求します。再設定URLは送信されません。</span>
                  </fieldset>
                  <v-divider />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="enableLoginButton"
              @click="backButtonClickEvent"
            >
              ログイン画面に戻る
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              @click="toNext"
            >
              送信
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'ForgetSelectSendForm',
  components: {},
  mixins: [],
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    enableLoginButton: {
      type: Boolean,
      default: () => true,
    },
  },
  data () {
    return {
      send_type: 'email',
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverForget', {
      sendUser: 'create',
    }),
    backButtonClickEvent () {
      this.$router.replace({ name: 'DriverSessions' })
    },
    toNext () {

      // emailあり、携帯電話番号なし
      if (this.user.email&&!this.user.mobile_number) {
        this.send_type = "email"
      // emailあし、携帯電話番号あり
      } else if (!this.user.email&&this.user.mobile_number) {
        this.send_type = "sms"
      // emailなし、携帯電話番号なし
      } else if (!this.user.email&&!this.user.mobile_number) {
        this.send_type = "admin"
      }

      let params = {login_id: this.user.login_id, send_type: this.send_type}
      this.sendUser({ params: params }).then(() => {
        this.$emit('toNextStep')
      })
    },
    toBack () {
      this.$emit('toBackStep')
    },
  }
}
</script>






